import type { LaunchpadSalePool, LaunchpadSalePoolType } from '@api';
import { LAUNCHPAD_SALE_POOL_TYPE } from '@api';

import { useAuth } from '@shared/common/providers/AuthProvider';

import {
  useGetFcfsAllocationsByPoolIdQuery,
  useGetProRataAllocationsByPoolIdQuery,
  useGetProRataSqrpGatedAllocationsByPoolIdQuery,
  useGetSqrpGatedAllocationsByPoolIdQuery,
} from '@query/launchpadProjects';

export const useRefetchAllocationsByPool = (sale?: LaunchpadSalePool) => {
  const { user } = useAuth();

  const { data: fcfsPoolAllocation, refetch: refetchFcfsPoolAllocation } =
    useGetFcfsAllocationsByPoolIdQuery(sale?.id || '', { enabled: !!user && !!sale?.id });
  const { data: sqrpGatedPoolAllocation, refetch: refetchSqrpGatedPoolAllocation } =
    useGetSqrpGatedAllocationsByPoolIdQuery(sale?.id || '', { enabled: !!user && !!sale?.id });
  const { data: proRataPoolAllocation, refetch: refetchProRataPoolAllocation } =
    useGetProRataAllocationsByPoolIdQuery(sale?.id || '', { enabled: !!user && !!sale?.id });
  const {
    data: proRataSqrpGatedGatedPoolAllocation,
    refetch: refetchProRataSqrpGatedGatedPoolAllocation,
  } = useGetProRataSqrpGatedAllocationsByPoolIdQuery(sale?.id || '', {
    enabled: !!user && !!sale?.id,
  });

  const refetchAllocationsByPool = () => {
    if (sale?.attributes.type) {
      switch (sale.attributes.type) {
        case LAUNCHPAD_SALE_POOL_TYPE.FCFS: {
          refetchFcfsPoolAllocation();
          break;
        }

        case LAUNCHPAD_SALE_POOL_TYPE.SQRP_GATED: {
          refetchSqrpGatedPoolAllocation();
          break;
        }

        case LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA: {
          refetchProRataPoolAllocation();
          break;
        }

        case LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA_SQRP_GATED: {
          refetchProRataSqrpGatedGatedPoolAllocation();
          break;
        }
      }
    }
  };

  const getSelfAllocationByPool = (poolType?: LaunchpadSalePoolType) => {
    if (!poolType) {
      return;
    }

    switch (poolType) {
      case LAUNCHPAD_SALE_POOL_TYPE.FCFS: {
        return fcfsPoolAllocation?.attributes?.amountBought;
      }

      case LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA: {
        return proRataPoolAllocation?.attributes?.amountBought;
      }

      case LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA_SQRP_GATED: {
        return proRataSqrpGatedGatedPoolAllocation?.attributes?.amountBought;
      }

      case LAUNCHPAD_SALE_POOL_TYPE.SQRP_GATED: {
        return sqrpGatedPoolAllocation?.attributes?.amountBought;
      }
    }
  };

  return { refetchAllocationsByPool, getSelfAllocationByPool };
};
